/**
 *  定义全局用户信息对象
 */
import { observable, action } from 'mobx'

class UserStore {

  @observable FUSER_ID = ''
  @observable FUSER_CODE = ''
  @observable FUSER_NAME = ''
  @observable FUSER_IMG = 'https://img11.360buyimg.com/jdphoto/s120x122_jfs/t5683/191/7076936752/5123/834e5571/596dd62bN7a8affc5.png'
  @observable FORG_ID = ''
  @observable FORG_CODE = ''
  @observable FORG_NAME = ''
  @observable FPURVIEW_ITEMS = {}

  @action signIn (_data) {
    this.FUSER_ID = _data.FMID
    this.FUSER_CODE = _data.FCODE
    this.FUSER_NAME = _data.FNAME
    this.FUSER_IMG = 'https://img11.360buyimg.com/jdphoto/s120x122_jfs/t5683/191/7076936752/5123/834e5571/596dd62bN7a8affc5.png'
    this.FORG_ID = _data.FORG_ID
    this.FORG_CODE = _data.FORG_CODE
    this.FORG_NAME = _data.FORG_NAME
    this.FPURVIEW_ITEMS = _data.FPURVIEW_ITEMS
  }

  @action signOut () {
    this.FUSER_ID = ''
    this.FUSER_CODE = ''
    this.FUSER_NAME = ''
    this.FUSER_IMG = ''
    this.FORG_ID = ''
    this.FORG_CODE = ''
    this.FORG_NAME = ''
    this.FPURVIEW_ITEMS = ''
  }
}

const userStore = new UserStore()

export default userStore


// WEBPACK FOOTER //
// ./src/wbap-core-commit/store/UserStore.js